import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { acceptInvite } from "../../services/memberService";
import styles from "./AcceptInvite.module.css";

export default function AcceptInvite() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const accept = async () => {
      try {
        const res = await acceptInvite(token);
        setStatus("success");
        setMessage(`Bem-vindo! Você entrou como ${res.data.role === "ADMIN" ? "Admin" : "Membro"}.`);
        setTimeout(() => navigate("/dashboard"), 2500);
      } catch (err) {
        setStatus("error");
        setMessage(err?.response?.data?.error ?? "Erro ao aceitar convite.");
      }
    };
    accept();
  }, [token, navigate]);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        {status === "loading" && <p>Processando convite...</p>}
        {status === "success" && (
          <>
            <div className={styles.icon}>✓</div>
            <h2>Convite aceito!</h2>
            <p>{message}</p>
            <p className={styles.redirect}>Redirecionando para o painel...</p>
          </>
        )}
        {status === "error" && (
          <>
            <div className={styles.iconError}>✗</div>
            <h2>Não foi possível aceitar o convite</h2>
            <p>{message}</p>
            <button onClick={() => navigate("/registration")} className={styles.btn}>
              Ir para o login
            </button>
          </>
        )}
      </div>
    </div>
  );
}
